module.exports = __webpack_public_path__ + "img/97.6452b627.jpg";